/* eslint-disable */
/* eslint-disable react/prop-types */
/* eslint-disable quotes */
import React from 'react';

import { useMemo, useState } from 'react';
//MRT Imports
import {
  MaterialReactTable,
  useMaterialReactTable,
  MRT_GlobalFilterTextField,
  MRT_ToggleFiltersButton,
} from 'material-react-table';

//Material UI Imports
import {
  Box,
  Button,
  Dialog,
  ListItemIcon,
  MenuItem,
  Typography,
  lighten,
} from '@mui/material';

//Icons Imports
import { Add, Edit, Delete } from '@mui/icons-material';

import FormComponent from './FormComponent';
const Material_React_Table = ({ data = [], columns = [] ,onRowAdd ,onRowUpdate,onRowDelete,userInitialState}) => {
  //  const Rawcompanies = useSelector((state) => state.companydata.company);
  console.log("Data:", Array.isArray(data) ? data.length : data);
  console.log("Data values in the material react table :",data);
  console.log("Columns:", Array.isArray(columns) ? columns.length : columns);
  console.log("Colums :",columns);

  // console.log("Intial state:", userInitialState)

  // console.log("Add Function :",onRowAdd);
  // console.log("Update Function :",onRowUpdate);
  // console.log("Delete Function :",onRowDelete);

  const [isModalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState(""); // 'add' or 'edit'
  const [selectedRow, setSelectedRow] = useState(null);

  const handleOpenModal = (type, rowData = null) => {
    setModalType(type);
    setSelectedRow(rowData);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedRow(null);
  };

  const handleFormSubmit = (values) => {
    if (modalType === "add") {
      console.log("Add method called from material react table");
      
      onRowAdd(values);
    } else if (modalType === "edit") {
      console.log("edit method called from material react table");
      onRowUpdate(values);
    }
    handleCloseModal();
  };


  const table = useMaterialReactTable({
    columns: useMemo(() => columns, [columns]),
    data: useMemo(() => data, [data]),
    enableColumnFilterModes: true,
    enableColumnOrdering: true,  
    enableGrouping: true,
    enableEditing: false, 
    editingMode: 'row',
    enableColumnPinning: true,
    enableFacetedValues: true,
    enableRowActions: true,
    //This is the default Material-react pop-ups
    // onEditingRowSave: ({ table, values }) => {
    //   //validate data
    //   //save data to api
    //   console.log("Update values :",values);
      
    //   onRowUpdate(values);
    //   table.setEditingRow(null); 
    // },
    // onEditingRowCancel: () => {
    //   //
    // },
    // onCreatingRowSave: ({ table, values }) => {
    //   console.log("Creating new row");
    //   console.log("New row values :",values);
    //   onRowAdd(values);
      
    //   //validate data
    //   //save data to api
    //   table.setCreatingRow(null); //exit creating mode
    // },
    // onCreatingRowCancel: () => {
    //   //clear any validation errors
    // },
    enableRowSelection: true,
    initialState: {
      ...{
        showColumnFilters: true,
        showGlobalFilter: true,
        columnPinning: {
          left: ['mrt-row-expand', 'mrt-row-select'],
          right: ['mrt-row-actions'],
        },
      },
      ...userInitialState,
    },
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
    },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [10, 20, 30],
      shape: 'rounded',
      variant: 'outlined',
    },
    renderRowActionMenuItems: ({ row, closeMenu }) => [

      <MenuItem
      key="edit"
      onClick={() => {
        closeMenu();
        handleOpenModal("edit", row.original);
      }}
      sx={{ m: 0 }}
    >
      <ListItemIcon>
        <Edit />
      </ListItemIcon>
      Update
    </MenuItem>,
     
      <MenuItem
        key={2}
        onClick={() => {
          closeMenu();
          if (onRowDelete) onRowDelete(row.original);
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <Delete />
        </ListItemIcon>
        Delete Row
      </MenuItem>,
    ],
    renderTopToolbar: ({ table }) => {
   
      // const handleAdd =()=>{
     
      //   table.setCreatingRow(true); //simplest way to open the create row modal with no default values
      //   //or you can pass in a row object to set default values with the `createRow` helper function
      //   // table.setCreatingRow(
      //   //   createRow(table, {
      //   //     //optionally pass in default values for the new row, useful for nested data or other complex scenarios
      //   //   }),
      //   // );
      // }
    

      

      return (
        <Box
          sx={(theme) => ({
            backgroundColor: lighten(theme.palette.background.default, 0.05),
            display: 'flex',
            gap: '0.5rem',
            p: '8px',
            justifyContent: 'space-between',
          })}
        >
          <Box sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <MRT_GlobalFilterTextField table={table} />
            <MRT_ToggleFiltersButton table={table} />
          </Box>
          <Box>
            <Box sx={{ display: 'flex', gap: '0.5rem' }}>
 
                <Button
                  color="info"
                  onClick={() => handleOpenModal("add")}
                  variant="contained"
                >
                  Add 
                </Button>
            
            </Box>
          </Box>
        </Box>


      );
      
    },
  });

  return (
    <>
      <MaterialReactTable table={table} />

      {/* Add/Edit Modal */}
      <Dialog open={isModalOpen} onClose={handleCloseModal} fullWidth maxWidth="sm">
      {isModalOpen && (
          <FormComponent
            modalType ={modalType}
            onClose={handleCloseModal}
            onSubmit={handleFormSubmit}
            data={selectedRow}
            columns={columns}
          />
        )}
      </Dialog>
    </>
  );
};

  
  


export default Material_React_Table;
